import React, { useContext, useEffect } from 'react';
import { StorefrontContext } from '../../../../../Context/StorefrontContext';
import { loadImage } from '../../../../../lib/utils/utils';
import { v4 as uuidv4 } from 'uuid';
import AddImage from '../../../../../Assets/Add image.svg';
import { CropImageContext } from '../../../../../Context/CropImageContext';

function ImageInput({ errorText }) {
    const {
        singleBannerDesktop,
        setSingleBannerDesktop,
    } = useContext(StorefrontContext);

    const { setImageToCrop, croppedImage, setCroppedImage, isImageCropped, setIsImageCropped, setModalOpen, setAspectRatio } = useContext(CropImageContext);

    async function handleImageChange(e) {
        const file = e.target.files[0];

        if(file) {
            setImageToCrop(file);
            setAspectRatio(12 / 5);
            setModalOpen(true);
            e.target.value = null;
        }
    }

    const handleDrop = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        setImageToCrop(file);
        setAspectRatio(12 / 5);
        setModalOpen(true);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const processFile = async (file) => {
        if(file) {
            const img = await loadImage(file);
            const selectedImage = {
                id: uuidv4(),
                url: img.src,
                file: file,
            }

            setSingleBannerDesktop({
                ...singleBannerDesktop,
                image: selectedImage,
            });
        }
        else {
            return;
        }
    }

    useEffect(() => {
        if(isImageCropped) {
            processFile(croppedImage);
            setIsImageCropped(false);
            setCroppedImage({});
            setModalOpen(false);
        }
    
        // eslint-disable-next-line
    }, [isImageCropped]);

    return (
        <div className='flex flex-col gap-2'>
            <div className="flex items-center justify-between">
                <p className='font-medium text-[14px] leading-6 text-[#121212]'>Banner Image <span className='text-[12px] text-[#666666]'>&#40;1440px * 600px&#41;</span></p>

                <p className='text-[12px] leading-5 text-[#EF4444]'>{errorText}</p>
            </div>

            <div 
                onDrop={handleDrop} 
                onDragOver={handleDragOver} 
                onDragLeave={handleDragLeave} 
                className="flex items-center gap-3"
            >
                {
                    singleBannerDesktop.image.url ? 
                    <div className="size-[100px] rounded-lg overflow-hidden flex items-center justify-center bg-[#F5F5F5]">
                        <img className='max-w-full max-h-full' src={singleBannerDesktop.image.url} alt="" />
                    </div> : 
                    <label htmlFor="banner-image" className="cursor-pointer size-[100px] rounded-lg overflow-hidden bg-[#666666] flex items-center justify-center">
                        <img className='size-1/2' src={AddImage} alt="" />
                    </label>
                }

                <input 
                    id='banner-image' 
                    name='banner-image' 
                    className='hidden'
                    type="file" 
                    accept='image/*' 
                    onChange={handleImageChange} 
                />

                <label htmlFor='banner-image' className='outline-none px-4 py-[6px] rounded-md bg-primaryColor hover:bg-primaryAccent font-semibold text-[12px] leading-6 text-buttonText cursor-pointer'>Change Image</label>
            </div>
        </div>
    );
}

export default ImageInput;
